import { fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';

export const DocWriteContainer = styled.div`
  background: #eef1f6;
  padding: 1.6rem 0;

  .approval_row_shadow {
    box-shadow: 0 0.4rem 2rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.4rem;
  }

  .approval_row_shadow:nth-child(n + 2) {
    box-shadow: 0 0.5rem 2rem -1rem rgba(0, 0, 0, 0.08), 0.5rem 0.5rem 2rem -1rem rgba(0, 0, 0, 0.08),
      -0.5rem 0.5rem 2rem -1rem rgba(0, 0, 0, 0.08);
  }

  .template-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .remove_btn {
    display: inline-block;
    margin-right: 0.8rem;

    img {
      vertical-align: middle;
    }
  }

  .category_chk_row {
    .approval_tit1 {
      margin-bottom: 0 !important;
      line-height: 3.2rem !important;
    }
  }

  .editor_wrap {
    width: 100% !important;
    display: flex;
    justify-content: space-between;

    .editor_tit {
      background: transparent !important;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.8rem 0 2.4rem !important;

      .temporary_tag {
        display: flex;
        min-width: 40px;
        height: 16px;
        align-items: center;
        justify-content: center;
        margin-right: 0.8rem;
        margin-top: 0.2rem;
        background: #fff06c;
        border-radius: 100px;
        font-size: 10px;
      }

      input {
        line-height: 3.2rem;
      }
    }

    .cke_bottom {
      background: transparent;
    }

    .cke_inner {
      background: transparent !important;
    }

    .editor_txt_wrap {
      width: 84rem;
      background: #fff;
      border-radius: 0.4rem;
      box-shadow: 0 0.4rem 2rem 0 rgba(0, 0, 0, 0.08);
    }

    .editor_list {
      background: #ffffff;
      width: 34.4rem;
      padding: 2.2rem;
      height: 70.2rem;
      overflow-y: auto;
      border-radius: 0.4rem;
      box-shadow: 0 0.4rem 2rem 0 rgba(0, 0, 0, 0.08);

      .list_empty {
        font-size: 1.2rem;
        color: #7783a1;

        img {
          vertical-align: middle;
          margin-right: 0.8rem;
        }

        .list {
          ${fontFamilyRegular};
          margin: 4px;
          padding-left: 12px;
          text-indent: -12px;
          line-height: 1.5;
        }

        .title {
          display: inline-block;
          padding-bottom: 10px;
        }

        .em {
          color: #407edb;
        }
      }
    }
  }

  .approval_row.row-pt-0 {
    border-top: solid 0.1rem #eef1f6;
    padding-top: 0 !important;
  }

  .approval_row.ls-row-pt-0 {
    border-top: solid 0.1rem #eef1f6;
    padding: 0 !important;
  }

  .sample-attach {
    box-shadow: 0 0.4rem 2rem 0 rgb(0 0 0 / 8%);
    border-radius: 0.4rem;
    background: #fff;
  }

  .sample-attach input {
    color: #000;
  }

  .sample-attach input::placeholder {
    font-size: 1.3rem;
  }

  .sample-attach .version_row {
    margin-top: 0;
  }

  .sample-attach .not-use-version {
    background: transparent;
  }

  .approval_tit1 {
    float: left;
    width: 12.5rem;
    margin-top: 1rem;
    font-size: 1.3rem;
  }

  .service-link-name {
    display: inline-block;
    border: 1px solid #c7d6ea;
    width: 12.8rem;
    height: 3.2rem;
    border-radius: 0.4rem;
    cursor: text;
    padding: 0.8rem 1.2rem;
    float: left;
    font-size: 1.2rem;

    ::placeholder {
      font-size: 1rem !important;
    }
  }

  .service-link {
    display: inline-block;
    border: 1px solid #c7d6ea;
    width: 23.8rem;
    height: 3.2rem;
    border-radius: 0.4rem;
    margin-left: 13.5rem;
    cursor: text;
    float: left;
    margin-top: -3.2rem;
    padding-left: 1rem;

    ::placeholder {
      font-size: 1rem !important;
    }
  }

  input::placeholder {
    font-size: 1rem;
    ${fontFamilyRegular};
    color: #7783a1;
  }

  .link-pc {
    float: left;
    display: block;
  }

  .link-name {
    float: left;
    padding-left: 1rem;
  }

  @media screen and (max-width: 1199px) {
    .editor_wrap .editor_txt_wrap {
      width: 100%;
      margin-bottom: 2rem;
    }

    .editor_wrap {
      display: inline-block;
    }
  }
  @media screen and (max-width: 1199px) and (min-width: 765px) {
    width: 100% !important;
    .approval_row.version_top {
      flex-wrap: wrap;

      .service-link {
        float: none;
        display: block;
      }

      .service-link-name {
        float: none;
        display: block;
      }

      > div {
        &:nth-child(2) {
          min-width: 83%;
        }

        &:nth-child(3) {
          padding-top: 0.8rem;
        }

        &:nth-child(4) {
          min-width: 83%;
          margin-top: 1rem;
        }
      }
    }
  }
  @media screen and (max-width: 870px) and (min-width: 765px) {
    .approval_row.version_top {
      > div {
        &:nth-child(2) {
          min-width: 73%;
        }

        &:nth-child(4) {
          min-width: 73%;
        }
      }
    }
  }
  @media screen and (max-width: 764px) {
    .link-name {
      padding-left: 0;
    }

    .service-link {
      margin-top: 0;
      margin-left: 14.5rem;
      margin-bottom: 2rem;
    }

    .service-link-name {
      margin-bottom: 1rem;
      margin-top: 1rem;
      width: 14rem;
    }

    .link-pc {
      width: 100%;
      float: none;
    }

    .approval_row.version_top {
      display: table-caption;
    }

    .approval_tit1 {
      width: 14.5rem !important;
      padding: 2.4rem 3.2rem 0 3.2rem;
    }
  }
  @media screen and (max-width: 1199px) {
    .template-wrap {
      &:has(.w-2) select.select-sm {
        width: calc(50% - 2px) !important;
      }
    }
  }
  @media screen and (max-width: 499px) {
    .template-wrap button {
      margin-left: 0;
      margin-top: 0.8rem;
    }

    .radio_wrap .approval_tit + div {
      width: calc(100% - 77px);
    }
  }
`;
